import { forwardRef, useRef } from 'react'
import type { TextInput } from 'react-native'

import { useTheme } from '~/hooks'

import * as S from './select-value.styles'

import { DISPLAY_NAME, useSelectContext } from '../../input-select'

import type { ScopedProps } from '../../input-select.types'

type SelectValueElementRef = React.ElementRef<typeof S.Value>

type SelectValueProps = {
  testID?: string
}

const SelectValue = forwardRef<SelectValueElementRef, SelectValueProps>(
  (props, ref) => {
    const theme = useTheme()

    const { testID, __scopeSelect } = props as ScopedProps<SelectValueProps>

    const {
      selectedValue,
      placeholder,
      options,
      isDisabled,
      isReadOnly,
      size,
      setTriggerToggle,
    } = useSelectContext(DISPLAY_NAME, __scopeSelect)

    const valueRef = useRef<TextInput | null>(null)

    const selectedItemLabel =
      options.find(option => option.value === selectedValue)?.label ?? ''

    const selectValueStates = {
      isDisabled,
      isReadOnly,
      size,
      isFilled: !!selectedValue,
    }

    const isEditable = !isDisabled && !isReadOnly

    return (
      <S.Value
        {...selectValueStates}
        ref={element => {
          if (typeof ref === 'function') {
            ref(element)
          }

          valueRef.current = element
        }}
        testID={testID}
        placeholderTextColor={theme.colorTextNeutralPlaceholder}
        showSoftInputOnFocus={false}
        onPressIn={() => setTriggerToggle('open')}
        value={selectedItemLabel}
        placeholder={placeholder}
        editable={isEditable}
        caretHidden
        autoComplete="off"
      />
    )
  }
)

SelectValue.displayName = 'SelectValue'

export { SelectValue }
